module.exports = __webpack_public_path__ + "img/zifen.3f637241.png";